import Store from 'Services/Store';

/**
 * Prepare country inputs before submitting form
 *
 * @returns {null}
 */
export const beforeSerialize = ($form, postOptions) => {

    var prepareSerialize = function() {
        $('.e164Number', $form).each(function(index, input) {
            var $input	= $(input);
            var country = $input.intlTelInput('getSelectedCountryData');
            $('.e164Country:first', $input.parents('.form-input:first')).val(country.iso2);
        });
    };

    // Prepare beforeSerialize post option
    if (postOptions.beforeSerialize) {
        var beforeSerialize = postOptions.beforeSerialize;
        // If already defined, we take care to not erase previous function
        postOptions.beforeSerialize = function() {
            beforeSerialize.call();
            prepareSerialize.call();
        };
    } else {
        postOptions.beforeSerialize = prepareSerialize;
    }
};

/**
 * Return defaultCountryCode set on your form
 *
 * @param {jQuery} $form
 * @returns {String}
 */
export const getDefaultCountryCode = ($form) => {
    var defaultCountryCode = $('.defaultCountryCode', $form).val();
    return !_.isUndefined(defaultCountryCode) ? defaultCountryCode.toLowerCase() : defaultCountryCode;
};

/**
 * Return preferred countries
 *
 * @param {string} defaultCountryCode
 * @returns {array}
 */
export const getPreferredCountries = (defaultCountryCode) => {
    return _.uniq([defaultCountryCode, 'fr', 'ch', 'be', 'us', 'gb']);
};

/**
 * Return nationalMode given the application preference
 *
 * @returns {Boolean}
 */
export const isNationalMode = () => {
    return Store.get('corp').phoneFormat != 'international';
};

/**
 * Prepare your phone form fields
 *
 * @param {jQuery} $form
 * @returns {undefined}
 */
export const prepareFields = ($form) => {
    var defaultCountryCode = getDefaultCountryCode($form);
    if (!_.isUndefined(defaultCountryCode)) {
        var preferredCountries = getPreferredCountries(defaultCountryCode);
        $('.e164Number', $form).each(function(index, input) {
            prepareOneField($(input), preferredCountries, defaultCountryCode);
            $(input).blur(function() {
                var value = $(this).val();
                var currentFormat = (value[0]==="+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                $(this).val( $(this).intlTelInput("getNumber",currentFormat));
            });
        });
    }
};

/**
 * "Static" function to prepare one phone field
 *
 * @param {jQuery} $input
 * @param {array} preferredCountries
 * @param {string} defaultCountryCode
 * @returns {undefined}
 */
export const prepareOneField = ($input, preferredCountries, defaultCountryCode, bypassSetCountry) => {
    var previousVal = $input.val();
    bypassSetCountry = _.isUndefined(bypassSetCountry) ? false : bypassSetCountry;
    // Initialize phone input
    var placeHolderType = $input.attr('name').indexOf('mobile') !== -1 ? 'MOBILE' : "FIXED_LINE_OR_MOBILE";

    $input.intlTelInput({
        formatOnDisplay		: true,
        nationalMode		: isNationalMode(),
        autoPlaceholder		: 'aggressive',
        placeholderNumberType : placeHolderType,
        preferredCountries	: preferredCountries,
        customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
            return "ex: " + selectedCountryPlaceholder;
        }
    });

    // Check if input has country
    var country = $input.intlTelInput('getSelectedCountryData');

    // If not, assign default country code, based on Sellsy object address
    if (!bypassSetCountry && !country.iso2) {
        // setCountry can throw exception if defaultCountryCode var is not managed
        // We just catch and console.log it to not block the current process
        try {
            $input.intlTelInput('setCountry', defaultCountryCode);
        } catch(e) {
            $input.intlTelInput('setCountry', preferredCountries[1]);
        }

        // If we can't retrieve the number, special case (like international numbers)
        // We can't unset the country with this library so we destroy current instance and will rebuild it avoiding setting of country
        if ($input.intlTelInput('getNumber') == '') {
            $input.intlTelInput('destroy');
            $input.val(previousVal);
            prepareOneField($input, preferredCountries, defaultCountryCode, true);
        }
    }
};
